module.exports = __webpack_public_path__ + "assets/08bbfe8bd6fadaa5a9e047f961fe38d9.png";